import { render, staticRenderFns } from "./StorageTermsView.vue?vue&type=template&id=6b8b1aa2&scoped=true&"
import script from "./StorageTermsView.vue?vue&type=script&lang=ts&"
export * from "./StorageTermsView.vue?vue&type=script&lang=ts&"
import style0 from "./StorageTermsView.vue?vue&type=style&index=0&id=6b8b1aa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b1aa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
